import { render, staticRenderFns } from "./SendMessageGroupFamilyDetailModal.vue?vue&type=template&id=2b0c7878&lang=pug"
import script from "./SendMessageGroupFamilyDetailModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupFamilyDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports